import ComponentTitle from "../ComponentTitle";
import ExperienceCard from "./ExperienceCard";
import {useEffect, useState} from "react";
import Aos from "aos";
import 'aos/dist/aos.css';
import {LandingPageService} from "../../../pages/Services/LandingPageService";

const Experience = ({experiences}) => {
    
    useEffect(() => {
        Aos.init({
            duration: 1000
        });
    }, [])
    
    return(
        <section 
            data-aos="fade-up" 
            id={"experience"} 
            className="py-20 bg-white dark:bg-slate-900 transition-colors duration-300 relative overflow-hidden"
        >
            {/* Subtle separator line top */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-slate-200 dark:via-slate-700 to-transparent"></div>
            
            <div className="container mx-auto px-6 lg:px-8 relative z-10">
                <ComponentTitle title={'Experience'} subTitle={'My professional journey and achievements'} />
                
                <div className="mt-16 space-y-8 max-w-4xl mx-auto">
                    {experiences?.map((experience, index) => (
                        <ExperienceCard key={experience.id || index} experience={experience} index={index} />
                    ))}
                </div>
            </div>
        </section>
    )
}
export default Experience;
